// services/frontend/src/components/signup/SignupProgressSteps.jsx
import React from 'react';

/**
 * [Why]
 * RN 앱의 회원가입 진행 단계(ProgressSteps) UI를 웹에서 동일한 UX로 제공하기 위한 컴포넌트입니다.
 *
 * [How]
 * - currentStep(1-based) 기준으로 완료/진행/대기 스타일을 구분합니다.
 */
export default function SignupProgressSteps({ currentStep = 1, totalSteps = 3 }) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  const colors = {
    activeBorder: '#6366f1',
    activeBg: '#eef2ff',
    inactiveBorder: '#e5e7eb',
    inactiveBg: '#ffffff',
    lineActive: '#a5b4fc',
    lineInactive: '#e5e7eb',
    textActive: '#1e1b4b',
    textInactive: '#9ca3af',
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, padding: '6px 0 14px 0' }}>
      {steps.map((step, idx) => {
        const isDone = step < currentStep;
        const isActive = step === currentStep;
        const circleBorder = isDone || isActive ? colors.activeBorder : colors.inactiveBorder;
        const circleBg = isActive ? colors.activeBg : colors.inactiveBg;
        const circleText = isDone || isActive ? colors.textActive : colors.textInactive;

        return (
          <React.Fragment key={step}>
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: 999,
                border: `2px solid ${circleBorder}`,
                background: circleBg,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 13,
                fontWeight: 600,
                color: circleText,
              }}
              aria-label={`회원가입 ${step}단계`}
            >
              {step}
            </div>
            {idx < steps.length - 1 && (
              <div
                style={{
                  width: 42,
                  height: 2,
                  borderRadius: 999,
                  background: step < currentStep ? colors.lineActive : colors.lineInactive,
                }}
                aria-hidden="true"
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
